var Theme;
(function (Theme) {
  Theme.getLight = function () {
    return {
      iconButtonBackground: 'white',
      iconButtonHoverBorder: '$slate9',
      iconButtonHoverBackground: '$slateA3',
      iconButtonFocusBorder: '$slate10'
    };
  };
  Theme.getDark = function () {
    return {
      iconButtonBackground: '$deepBlue2',
      iconButtonHoverBorder: '$deepBlue6',
      iconButtonHoverBackground: '$slateA4',
      iconButtonFocusBorder: '$deepBlue7'
    };
  };
})(Theme || (Theme = {}));

export { Theme };
